//Proofed
import EditNoteIcon from '@mui/icons-material/EditNote'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import SchoolIcon from '@mui/icons-material/School'
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk'
import DescriptionIcon from '@mui/icons-material/Description'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import type { HowItWorksStep } from '../components/HowItWorksSection'

export const bidHighlights = [
    'Human expertise alongside our CFP platform',
    'Bid writing support for high-value or complex opportunities',
    'Pre-submission bid reviews and scoring',
    'Targeted market research and market data',
    'Guided onboarding for teams new to public sector bidding',
]
export const bidHIWTitle = "How it works"
export const bidHIWSubtitle = "Simple, scoped and fast from first call to delivered work"

export const bidSteps: HowItWorksStep[] = [
    {
        num: '1',
        Icon: PhoneInTalkIcon,
        title: 'Discovery Call',
        body: "Tell us about the opportunity, the deadline and your current capacity. We'll assess fit, ask the right questions and confirm we can add value before scoping anything",
    },
    {
        num: '2',
        Icon: DescriptionIcon,
        title: 'Proposal & Kick-off',
        body: 'We agree scope, deliverables, timeline and pricing upfront. No surprises. Kick-off happens fast typically within 48 hours of confirmation',
    },
    {
        num: '3',
        Icon: TaskAltIcon,
        title: 'Delivery & Handover',
        body: 'Work is delivered on time, reviewed with you and handed back ready to use. We stay available for final questions until submission',
    },
]

export const bidTriggers = [
    {
        heading: "High-value bid you can't afford to lose",
        body: "A large contract is on the table and your internal team needs expert reinforcement a second pair of eyes or a writer who knows what buyers want to see",
    },
    {
        heading: 'Team stretched across too many submissions',
        body: 'Deadlines are stacking up and capacity is tight. We provide professional bid writing support on demand without the cost of a permanent hire',
    },
    {
        heading: 'New to public sector and need a guide',
        body: "You're ready to enter the public sector market but want expert guidance on how procurement works, what buyers expect and how to position your first bid to win",
    },
]

export const bidServices = [
    {
        Icon: EditNoteIcon,
        title: 'Bid Writing Support',
        body: 'Expert writers engaged on a specific tender. We work from your knowledge base, interview your team and produce responses that are compliant, evidence-led and scored to win',
        tag: 'Most popular',
    },
    {
        Icon: FactCheckIcon,
        title: 'Bid Review & Scoring',
        body: "Already drafted your bid? We sense-check structure, compliance, win themes and scoring before you submit giving you the confidence to go in strong",
        tag: null,
    },
    {
        Icon: QueryStatsIcon,
        title: 'Market Research & Data Drops',
        body: "Need to understand a specific buyer, sector, or framework before you bid? We produce a targeted intelligence report buyer history, procurement patterns, competitor context to support your strategy",
        tag: null,
    },
    {
        Icon: SchoolIcon,
        title: 'New to Public Sector Onboarding',
        body: "Structured 1:1 guidance for businesses entering the public sector for the first time. Covers how procurement works, registration, framework entry and what buyers actually look for",
        tag: null,
    },
]

export const bidWhoFor = [
    {
        role: 'Bid Managers',
        desc: 'Who need expert surge capacity when multiple deadlines collide or a high-stakes bid requires specialist input',
    },
    {
        role: 'Commercial Directors',
        desc: 'Who want a senior review before an important submission goes in independent scoring, honest feedback',
    },
    {
        role: 'BD Leads entering public sector',
        desc: 'Who need a guide through the process procurement rules, buyer expectations and how to position compellingly',
    },
    {
        role: 'SMEs and founder-led teams',
        desc: "Without an in-house bid function who need professional bid writing support on high-value tenders without the cost of a full-time hire",
    },
]


export const bidFaqs = [
    {
        q: 'How is advisory pricing structured?',
        a: 'All advisory services are priced case-by-case based on scope, deadline and complexity. We provide a fixed-price proposal before any work begins no hidden fees or open-ended retainers',
    },
    {
        q: 'Do I need a CFP Core subscription to use advisory services?',
        a: "No advisory services are available independently. However, most of our clients use CFP Core alongside advisory support, as the platform data significantly improves the quality of our research and bid intelligence",
    },
    {
        q: "What's the typical turnaround for a bid review?",
        a: "Most bid reviews are completed within 2-7 working days of receiving the draft depending on length",
    },
    {
        q: 'Can you write a full bid from scratch?',
        a: "Yes. Our bid writing support service covers everything from question extraction and storyboarding through to full draft responses. We'll need access to your supporting documents, case studies and a kick-off call to understand your win themes",
    },
    {
        q: "What's a data drop?",
        a: "A data drop is a targeted intelligence report on a specific buyer, sector or framework. It typically covers the buyer's procurement history, current suppliers, contract values, renewal timelines and any competitive intelligence relevant to your bid strategy",
    },
    {
        q: 'Can advisory services be combined with Tender Ninja?',
        a: 'Yes and the combination works well. Tender Ninja accelerates the drafting phase using your documents. Our advisory team can review, score and strengthen the outputs before submission',
    },
]
